import Loader from "../../layouts/loader/Loader";
import { useAppDispatch, useAppSelector } from "../../redux/store";
import { setResponseValue } from "../../redux/features/api-response/api-response";
import Res from "./APIResponse";

const ApiResponsePopup = () => {
  // #region variables region
  const success = useAppSelector((state) => state.responseSlice.success);
  const pending = useAppSelector((state) => state.responseSlice.pending);
  const error = useAppSelector((state) => state.responseSlice.error);
  const message = useAppSelector((state) => state.responseSlice.message);

  // dispatch for redux
  const dispatch = useAppDispatch();

  // #endregion

  // #region methods region

  // closes the message notification
  const handleClosePopup = (closeModal: { name: string; value: boolean }) => {
    dispatch(setResponseValue(closeModal));
  };

  // #endregion

  return (
    <div>
      {pending && <Loader isShow={pending} />}
      {(success || error) && (
        <Res
          message={message}
          isOpen={success || error}
          isSuccess={success ? true : false}
          closeModal={
            success
              ? { name: "success", value: false }
              : { name: "error", value: false }
          }
          handleClosePopup={(closeModal: { name: string; value: boolean }) =>
            handleClosePopup(closeModal)
          }
        />
      )}
    </div>
  );
};

export default ApiResponsePopup;
